// Module
var code = "<div class=\"progress\"> <div aria-valuemax=\"100\" aria-valuemin=\"0\" aria-valuenow=\"{{vm.progressValue}}\" class=\"progress-bar\" role=\"progressbar\" ng-class=\"vm.classed\" ng-style=\"{width: (vm.progressValue)+'%'}\"> <span>{{vm.progressValue|number:0}}%</span> </div> </div>";
// Exports
module.exports = code;